import React from "react";

export const HeaderContent = () => {
    return (
        <div className="width-100pct height-100pct bg-white bg-white display-flex align-items-center" style={{ borderBottom: '1px solid var(--gray-light)' }}>
            <svg className="fill-primary" width="50" height="50" xmlns="http://www.w3.org/2000/svg">
                <path d="M0 50V0h50v50H0zm45.3-23.95c0-4.55-3.7-8.25-8.25-8.25s-8.25 3.7-8.25 8.25 3.7 8.25 8.25 8.25 8.25-3.7 8.25-8.25zm-23.6 7.8h5.05V18.2H21.7v15.65zm-8-15.65H5.25v15.65h4.9V27.6l4.25 6.25h5.35l-4.1-6.25c.45-.15.85-.4 1.15-.7 1.1-.9 1.8-2.3 1.8-3.8 0-2.7-2.2-4.9-4.9-4.9z" fill-rule="evenodd">
                </path>
            </svg>
            <span className="text-size-h5 text-medium margin-left-20">AI ROUTE</span>
        </div>
    )
}
